import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.white,
    height: "fit-content",
    width: "100%",
    borderRadius: 14,
    padding: theme.spacing(5, 7),
    paddingBottom: 0,
    position: "relative",
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  innerContainer: {
    height: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.background.darkGray,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.background.darkGray,
    },
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    padding: theme.spacing(4, 0),
  },
  buttonPrimary: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    width: 140,
    height: 42,
    marginRight: 15,
    fontWeight: 400,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  buttonSecondary: {
    color: theme.palette.Primary.background,
    borderColor: theme.palette.Primary.background,
    textTransform: "capitalize",
    width: 120,
    height: 42,
    "&:hover": {
      borderColor: theme.palette.Primary.background,
      backgroundColor: theme.palette.Secondary.hoverButton,
    },
    marginRight: theme.spacing(5),
  },
  backContainer: {
    color: theme.palette.Primary.background,
    textTransform: "capitalize",
    display: "flex",
    paddingBottom: 35,
    paddingTop: 10,
    alignItems: "center",
    cursor: "pointer",
  },
  addRole:{
    display: "flex",
    color: theme.palette.icon.blue,
  },
  roleBox:{
    backgroundColor: theme.palette.Primary.light,
    padding: theme.spacing(5),
    borderRadius: 8,
    border: "1px solid #8B2147",
    margin: theme.spacing(5,0),
  },
  justCheckSelected: {
    "& > fieldset > legend": {
      display: "none !important",
    },
  },
  label: {
    margin: "0px !important",
    "&.Mui-focused": {
      margin: "0px !important",
      display: "none !important",        },
        "&.MuiFormLabel-filled":{
          margin: "0px !important",
          display: "none !important",        }
  },
  multiSelect: {
    width: "90%",
    margin: theme.spacing(3, 0),
    height: 55,
    paddingTop: theme.spacing(1),
    borderColor: "black !important",
    borderRadius: "4 !important",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
      borderRadius: 4,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
      borderRadius: 4,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
      borderRadius: 4,
    },
  },
  textAreaContainer:{
    width: "80%",
    marginRight: theme.spacing(8)
  },
  autoComplete:{
    width: "92%",
  },
  select:{
    width: "92%"
  },
  roleType:{
    width: "90%"
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  checkbox: {
    color: "#8C2148 !important",
    borderWidth: 1,
  },
  addCountryFacility:{
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));

export default useStyles;
